import MonacoEditor from '@monaco-editor/react'
import { useEffect, useRef, useState } from 'react';
import { buildSchema } from 'graphql';
import { graphql } from 'cm6-graphql';
import CodeMirror from '@uiw/react-codemirror';
import { Box } from '@mui/material';

export const GraphQLEditor = (props: any) => {

    const schema = `
          scalar Int
          scalar Float
          scalar DateTime
          scalar JSON
              type User {
                  id: ID!
                  name: String
                  email: String
                  price: Float
                }
              
                type Query {
                  getUser(id: ID!): User
                }
              
                type Mutation {
                  updateUser(id: ID!, name: String): User
                }`

    const [code, setCode] = useState(props.initialValue || '')

    return (
      <Box sx={{flex: 1, display: 'flex', '& .cm-editor': {flex: 1}}}>
      <CodeMirror
        style={{
          flex: 1,
          display: 'flex'
        }}
        value={code}
        onChange={(value) => setCode(value)} 
        extensions={[graphql(buildSchema(props.schema))]} />    
      </Box>
    );
    //     <MonacoEditor
    //         beforeMount={handleEditorWillMount}
    //         value={props.value}
    //         defaultLanguage={"graphql"} />
    // )
}